import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class FechaService {

  constructor() { }

  getFecha(s: string): Date {
    try {
      if (s && s.length > 0) {
        const d = new Date(s);
        if (d != null) {
          d.setDate(d.getDate() + 1);
          d.setHours(0);
          d.setMinutes(0);
          d.setSeconds(0);
          d.setMilliseconds(0);
          return d;
        }
      }
    } catch (e) { }
    return null;
  }

  getInputValue(n: number): string {
    const f = new Date(n);
    const year = f.getFullYear();
    const m = f.getMonth() + 1;
    const month = m < 10 ? `0${m}` : m;
    const day = f.getDate() < 10 ? `0${f.getDate()}` : f.getDate();
    return `${year}-${month}-${day}`;
  }

  getDateTimeValue(f: Date): string {
    const year = f.getFullYear();
    const m = f.getMonth() + 1;
    const month = m < 10 ? `0${m}` : m;
    const day = f.getDate() < 10 ? `0${f.getDate()}` : f.getDate();
    const h = f.getHours();
    let hour: any = 0;
    let am_pm = '';
    if (h === 0) {
      hour = 12;
      am_pm = 'am';
    } else if (h > 0 && h <= 12) {
      if ( h < 10 ) {
        hour = `0${h}`;
      } else {
        hour = h;
      }
      am_pm = 'am';
    } else if (h > 12) {
      hour = h - 12;
      am_pm = 'pm';
    }
    const mi = f.getMinutes();
    const min = mi < 10 ? `0${mi}` : mi;
    return `${year}/${month}/${day} ${hour}:${min} ${am_pm}`;
  }

  compare(d1: Date, d2: Date): number {
    const f1 = d1.getTime();
    const f2 = d2.getTime();

    if (f1 > f2) {
      return 1;
    } else if (f2 > f1) {
      return -1;
    } else {
      return 0;
    }
  }

  getDifferenceInYears(d1: Date, d2: Date) {
    let diff = (d2.getTime() - d1.getTime()) / 1000;
        diff /= (60 * 60 * 24);
    return Math.abs(Math.round(diff / 365.25));
  }

  getFirstDayOfMonth(d: Date): Date {
    let date = new Date(d.getFullYear(), d.getMonth(), 1);
    date = this.clearDate(date);
    return date;
  }

  clearDate(d: Date, last ?: boolean): Date {
    const date = new Date(d.getTime());
    if(last) { 
      date.setHours(23);
      date.setSeconds(59);
      date.setMilliseconds(59);
    } else {
      date.setHours(0);
      date.setSeconds(0);
      date.setMilliseconds(0);
    }
    return date;
  }
}
